import proj4 from 'proj4';
import { environment } from '../environment.enum';
import { getEnvKey } from '../environments';
import { ServiceManager } from '../services/service-manager';

export class BagSearch {
    bagId?: string;

    constructor() { }
}

export class GeoSearch {
    country?: string;
    city?: string;
    houseNumber?: string;
    houseNumberAddition?: string;
    houseLetter?: string;
    street?: string;
    county?: string;
    state?: string;
    postalcode?: string;
    query?: string;

    constructor() {
        this.country = 'Nederland';
        this.city = '';
        this.houseNumber = '';
        this.street = '';
        this.county = '';
        this.state = '';
        this.postalcode = '';
        this.query = '';
    }
}

export class GeolocationHelper {
    readonly epsg28992 = '+proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.9999079 +x_0=155000 +y_0=463000 +ellps=bessel +units=m +no_defs';

    adressToLatLongViaOpenStreetMap(search: GeoSearch): Promise<{ response: Response, data: { lon: string, lat: string, display_name: string }[] }> {
        let response: Promise<{ response: Response, data: any }>;
        if (search.query) {
            response = ServiceManager.httpService.get(`https://nominatim.openstreetmap.org/search.php?q=${search.query}&polygon_geojson=0&format=jsonv2&debug=0`, { successMessage: 'Adressen zijn opgehaald. Kies een locatie.' });
        } else {
            response = ServiceManager.httpService.get(`https://nominatim.openstreetmap.org/search.php?country=${search.country}&city=${search.city}&street=${search.houseNumber} ${search.street}&postalcode=${search.postalcode}&polygon_geojson=0&format=jsonv2&debug=0`, { successMessage: 'Adressen zijn opgehaald. Kies een locatie.' });
        }
        return response;
    }

    async getCoordinatesByPerceelnummer(kadastraalPerceelnummer) {
        const apiUrl = "https://api.pdok.nl/bzk/locatieserver/search/v3_1/free";

        const query = {
            q: `${kadastraalPerceelnummer}`,
            fq: "type:perceel",
            rows: "1",
            fl: "centroide_rd,centroide_ll,perceelnummer"
        };

        try {
            const response = await fetch(`${apiUrl}?${new URLSearchParams(query)}`, {
                method: "GET",
                headers: {
                    "Accept": "application/json"
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();
            console.log(data);
            if (data.response.numFound > 0) {
                const result = data.response.docs[0];
                const rdCoords = result.centroide_rd;
                const latLonCoords = result.centroide_ll;
                const perceelnummer = result.perceelnummer;

                const rdMatch = rdCoords.match(/POINT\((\d+\.?\d*)\s(\d+\.?\d*)\)/);
                const llMatch = latLonCoords.match(/POINT\((\d+\.?\d*)\s(\d+\.?\d*)\)/);

                return {
                    rd: { x: rdMatch?.[1], y: rdMatch?.[2] },
                    wgs84: { lat: llMatch?.[2], lon: llMatch?.[1] },
                    perceelnummer: perceelnummer
                };
            } else {
                console.log("No parcel found with this number.");
                return undefined;
            }
        } catch (error) {
            console.error("Error fetching coordinates:", error);
            return undefined;
        }
    }

    async adressToLatLongKadaster(search: GeoSearch) {
        const response = await fetch(
            `https://api.bag.acceptatie.kadaster.nl/lvbag/individuelebevragingen/v2/adressenuitgebreid?exacteMatch=false&${search.postalcode && `postcode=${search.postalcode}&`}${search.houseNumber && `huisnummer=${search.houseNumber}&`}${search.houseNumberAddition && `huisnummertoevoeging=${search.houseNumberAddition}&`}${search.houseLetter && `huisletter=${search.houseLetter}&`}${search.city && !search.postalcode && `woonplaatsNaam=${search.city}&`}${search.street && `openbareRuimteNaam=${search.street}&`}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Api-Key': getEnvKey((process.env.REACT_APP_ENVIRONMENT as environment), 'bagKey'),
                    'Content-Crs': 'epsg:28992',
                    'Accept-Crs': 'epsg:28992',
                }
            }
        );

        let json = await response.json();
        return json;
    }


    async siteSearch(lat: number, lon: number) {
        const s = this.toEpsg28992(lon, lat);
        const response = await fetch(
            `https://brk.basisregistraties.overheid.nl/api/v1/percelen/_zoek`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'X-Api-Key': getEnvKey((process.env.REACT_APP_ENVIRONMENT as environment), 'bag'),
                    'Content-Crs': 'epsg:28992',
                    'Accept-Crs': 'epsg:28992',
                },
                method: 'POST',
                body: JSON.stringify({
                    "geometry": {
                        "contains": {
                            "type": "Point",
                            "coordinates": [
                                s[0],
                                s[1]
                            ]
                        }
                    }
                })
            }
        );

        let json = await response.json();
        return json;
    }

    toEpsg28992(lon: number, lat: number) {
        return proj4('WGS84', this.epsg28992, [lon, lat]);
    }

    toWGS84(lon: number, lat: number) {
        return proj4(this.epsg28992, 'WGS84', [lon, lat]);
    }
}